// cSpell:ignore aangemaakt Aanvulling Alles betaald Betaalopdrachten betaalopdrachten bevestigen Bezig Bouwlaan buiten concepten downloaden eigenaar Eindafrekening forfait Geen hele keer Keuze kosten leeft lokale Opslaan Overzicht pand pand's panden refetches Samenvatting stappenplan Verdeling Versturen vertrek Verwerking Volgende Vorige wordt
/* eslint-disable no-nested-ternary */
import { isPerformingSubmitActionSelector } from "@rentiohq/shared-frontend/dist/forms/createPayment/schema.createPayment.actions";
import { generateFormId } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import * as brokerHooks from "@rentiohq/shared-frontend/dist/reduxV2/broker/broker.hooks";
import api from "@rentiohq/shared-frontend/dist/utils/api/api.utils";
import {
  confirm as confirmDialog,
  IConfirm,
} from "@rentiohq/shared-frontend/dist/utils/confirm.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import {
  Banner,
  Button,
  Card,
  DisplayText,
  Grid,
  Loading,
  OptionListShared,
  Select,
  Stack,
  TextStyle,
} from "@rentiohq/web-shared/dist/components";
import { ButtonGroup } from "@rentiohq/web-shared/dist/components/ButtonGroup";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useSelector, useStore } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PaymentForm as PaymentFormContainer } from "scenes/Properties/scenes/Payments/scenes-v2/PaymentForm";
import {
  buildingAddressOf,
  buildingSectionTitle,
  settledInLabels,
  settlementSlicesFor,
  wizardSettlementCosts,
  withSettlementSlices,
} from "../../../buildingSettlement.utils";
import { OwnerGroupList } from "../../../components/OwnerGroupList";
import { departureSharesByCost } from "../../../costSettlementState.utils";
import {
  departureBlockOf,
  departuresInScope,
  TDepartureBlock,
} from "../../../departure.utils";
import {
  confirmedCorrectionsBySettlement,
  settledLeaseRows,
} from "../../../departureCorrection.utils";
import {
  departureDefaultStart,
  lastSettledDayOfLease,
  leaseSettledThrough,
} from "../../../departureStart.utils";
import { computeResult } from "../../../engine";
import {
  earliestDay,
  unitAddressLabel,
  unitDisplayLabel,
  unitsExistingSince,
  withArchivedUnits,
} from "../../../groupUnits.utils";
import {
  useAssignableProperties,
  useGroupRentalContracts,
  useGroupUnits,
  useInvoices,
  useKeys,
  useAccountContacts,
  useProvisionSchedules,
  usePropertyOwners,
  usePropertyRentalContractsState,
  useSettlement,
  useSettlements,
} from "../../../hooks";
import {
  fetchLeaseOneOffOrders,
  fetchStoredSettlement,
  findInviteBlocks,
  getInviteBlockedInfo,
  IInviteBlock,
} from "../../../inviteGuard.utils";
import { todayIsoDay } from "../../../localDay.utils";
import {
  canPayPerOwner,
  getNextOpenRunIndex,
  getOwnerPayRuns,
  groupSharesByOwner,
} from "../../../ownerPayGroups.utils";
import {
  getEffectivePayerId,
  getPayerName,
  getPayerOptionLabel,
  IPayerCandidate,
  joinRecipientNamesAmong,
} from "../../../payer.utils";
import { ProvisionSlice } from "../../../provisionHistory";
import {
  leaseAccountIds,
  settledProvisionsInTree,
} from "../../../settledProvisions.utils";
import { settlementDisplayName } from "../../../settlementName.utils";
import { getSettlementPaymentDescription } from "../../../settlementPayment.utils";
import {
  buildInvoiceFigures,
  freezeKeyWeights,
} from "../../../settlementView.utils";
import {
  IStatementAddresses,
  leasePostalAddress,
  statementOfficeOf,
} from "../../../statementParties.utils";
import {
  categoryLabel,
  Invoice,
  isDepartureSettlement,
  Settlement,
  settlementEligible,
  SettlementDraftState,
  SettlementSnapshot,
} from "../../../types";
import { useWithArchivedPropertiesState } from "../../../useArchivedProperties";
import { PaymentStepBanner } from "./PaymentStepBanner";
import { confirmInTurn } from "./postRunDialogs.utils";
import {
  getSaveFailedTextKey,
  getSaveFailedTextParams,
  isDepartureChangedRefusal,
  isPaymentStillOpenRefusal,
  isStaleCostsRefusal,
} from "./saveFailed.utils";
import {
  afterNextPaint,
  changedSettlementActions,
  getNextOpenShareIndex,
  getOrderPayerNames,
  getOwingTenantsFromSnapshot,
  handleSingleChoice,
  hasPendingWizardLinks,
  IOwingTenant,
  IPayShare,
  linkCreatedOrders,
  MIN_PAYABLE_AMOUNT,
  withWizardLinks,
} from "./SettlementForm.utils";
import {
  departureEndsTooFarAhead,
  diffReviewedCosts,
  getConfirmPrimaryLabelKey,
  getAutoSelectedInvoiceIds,
  getDraftSettlementName,
  getIdSetFromKey,
  getIdSetKey,
  getInvoicesStepErrorKey,
  getPeriodStepErrorKey,
  getPeriodStepErrors,
  hasUnsavedWizardInput,
  IReviewedCostsDiff,
  isNothingToSettle,
  isReviewedCostsDiffEmpty,
  overlappingSettlementNames,
  proposeSettlementPeriod,
  withAutoSelectedInvoices,
  withDepartureLeaseEnd,
  withoutRemovedCosts,
} from "./settlementWizard.utils";
import { StepNavigation, StepDef } from "./StepNavigation";
import {
  buildStatementSnapshot,
  StatementSnapshot,
  statementVariant,
} from "./steps/buildStatementSnapshot";
import { ConfirmedView } from "./steps/ConfirmedView";
import { btwOf, fmt, fmtDate, StepHeader } from "./steps/shared";
import { Step2Distribution, Step2Validate } from "./steps/Step2Distribution";
import { Step3Provisions } from "./steps/Step3Provisions";
import { Step4Summary } from "./steps/Step4Summary";
import { StepInvoices } from "./steps/StepInvoices";
import { StepPeriod } from "./steps/StepPeriod";
import { buildCatMeta, tenantOwedInclVat } from "./steps/summaryCards.utils";
import { useLeaveGuard } from "./useLeaveGuard";
import { useOnUnmount } from "./useOnUnmount";
import { WizardFooter } from "./WizardFooter";

// Built per render, not at module load: getLocalizedText resolves against the
// locale at call time, so a module-level constant would freeze the labels in
// whatever language was active when the bundle first evaluated.
const stepsGroup = (): StepDef[] => [
  { key: "period", title: getLocalizedText("costs.field.period") },
  { key: "invoices", title: getLocalizedText("settlement.invoices.title") },
  // Always part of the group wizard: you always have to pick costs, so hiding
  // this until a common cost is ticked only made the stappenplan jump around.
  // With no common costs selected the step shows its own empty state.
  // The step holds every distribution method, not only the key.
  {
    key: "keys",
    title: getLocalizedText("settlement.distribution.step_title"),
  },
  { key: "provisions", title: getLocalizedText("settlement.provisions.title") },
  { key: "summary", title: getLocalizedText("settlement.summary.title") },
];

const stepsUnit = (): StepDef[] => [
  { key: "period", title: getLocalizedText("costs.field.period") },
  { key: "invoices", title: getLocalizedText("settlement.invoices.title") },
  { key: "provisions", title: getLocalizedText("settlement.provisions.title") },
  { key: "summary", title: getLocalizedText("settlement.summary.title") },
];

export interface SettlementFormProps {
  settlementId?: string;
  property: { id: number | string; name?: string };
  // New mode: no DB row yet; the wizard runs entirely from local state until
  // the user commits to Step 1's period, at which point we lazily POST the
  // settlement and replace the URL. Present only on the /add route.
  virtualScope?: {
    scope: "unit" | "group";
    groupId?: string;
    unitId?: string;
    // A departure settlement for this lease of the unit (see
    // ISettledDeparture).
    departureContractId?: string;
  };
  // The settled property is archived: a confirmed settlement is only read.
  readOnly?: boolean;
}

const emptyDraft = (
  periodFrom: string,
  periodTo: string,
): SettlementDraftState => {
  return {
    stepIndex: 0,
    period: { from: periodFrom, to: periodTo },
    selectedInvoiceIds: {},
    distributionMethod: {},
    selectedKeyId: {},
    consumption: {},
    buildingTotal: {},
    excessMode: {},
    companyAmounts: {},
    actions: {},
  };
};

const defaultLastYearPeriod = () => {
  const year = new Date().getFullYear();
  return { from: `${year - 1}-01-01`, to: `${year - 1}-12-31` };
};

export const SettlementForm: React.FC<SettlementFormProps> = ({
  settlementId,
  virtualScope,
  readOnly = false,
}) => {
  const navigate = useNavigate();
  const isNewMode = !settlementId && !!virtualScope;

  const {
    settlement: fetchedSettlement,
    updateDraft,
    recordActions,
    confirm,
    refetch: refetchSettlement,
    reload: reloadSettlement,
  } = useSettlement(settlementId);

  // Local synthetic settlement for /add. Enough of the shape for the wizard's
  // read paths (scope, groupId/unitId, status, draftState placeholder). The
  // real DB row is created lazily by `materializeSettlement` below.
  const virtualSettlement = useMemo(() => {
    if (!isNewMode || !virtualScope) return null;
    const defaultPeriod = defaultLastYearPeriod();
    return {
      id: "",
      scope: virtualScope.scope,
      groupId: virtualScope.groupId,
      unitId: virtualScope.unitId,
      status: "draft" as const,
      periodFrom: defaultPeriod.from,
      periodTo: defaultPeriod.to,
      draftState: emptyDraft(defaultPeriod.from, defaultPeriod.to),
      createdAt: todayIsoDay(),
    };
  }, [isNewMode, virtualScope]);

  // Keep the last known-good fetched settlement: a background refetch that
  // briefly yields `undefined` must not blank the wizard (it would unmount the
  // embedded payment flow and lose the user's place).
  const lastFetchedSettlement = useRef(fetchedSettlement);
  if (fetchedSettlement) lastFetchedSettlement.current = fetchedSettlement;
  const settlement = isNewMode
    ? virtualSettlement
    : fetchedSettlement ?? lastFetchedSettlement.current;

  // Create endpoint for lazy materialization on first meaningful step commit.
  const settlementListFilter = useMemo(
    () =>
      virtualScope?.scope === "group"
        ? { groupId: virtualScope.groupId }
        : { unitId: virtualScope?.unitId },
    [virtualScope?.scope, virtualScope?.groupId, virtualScope?.unitId],
  );
  const {
    create: createSettlementApi,
    recordActions: recordSettlementActions,
  } = useSettlements(settlementListFilter);
  // The settlement row once it is persisted. Saving happens BEFORE the
  // payment steps (Lewis, 2026-10-05): the server guard can refuse while
  // nothing has been created yet, and a failed payment never leaves an order
  // without a settlement — the confirmed view can still create it later.
  const savedSettlementRef = useRef<Settlement | null>(null);
  // Id of the settlement this wizard saved itself (new mode creates it on
  // confirm, before the payment steps). Once the list refetches it is a
  // confirmed settlement like any other, and without this it would count as
  // "settled elsewhere": every cost and provision month of the wizard then
  // dropped out and the payment step found no tenant to bill.
  const [ownSavedId, setOwnSavedId] = useState<string | undefined>();
  const ownId = settlementId ?? ownSavedId;

  // Real rental contracts of the settled property (unit) or every unit of the
  // building (group) — replaces the old mock useContracts. Both hooks are called
  // unconditionally (React rules); the inactive one runs with an empty input.
  const { items: assignable, isFetching: isFetchingAssignable } =
    useAssignableProperties();
  // The property list leaves archived properties out: the settled one is
  // added when archived, so a unit still knows its group (which decides the
  // provision slice it settles) and its address. Unmarked, as the statements
  // of a confirmed settlement are built from it too.
  const {
    properties: settledProperties,
    isResolving: isResolvingSettledProperty,
  } = useWithArchivedPropertiesState({
    properties: assignable,
    isFetching: isFetchingAssignable,
    ids: [settlement?.unitId ?? settlement?.groupId],
    marked: false,
  });
  // Group scope: include the child units' own settlements. A unit cost settled
  // from a settlement on that unit must count as settled here too, or the
  // group wizard offers it again and the tenant is billed for it twice.
  // Unit scope: include the parent group's settlements, for the same reason
  // the other way round (a legacy group-cost child lives on the unit).
  const parentGroupId =
    settlement?.scope === "unit"
      ? settledProperties.find(p => p.id === settlement.unitId)?.parentId
      : undefined;
  // A departure settlement (see ISettledDeparture) settles one lease of the
  // unit: its share of the unit's own costs and, for a unit in a group, of the
  // group's costs, split over the group's units by a key as a group
  // settlement does.
  const departureContractId =
    settlement?.scope === "unit"
      ? virtualScope?.departureContractId ??
        settlement.draftState?.departure?.contractId ??
        ("snapshot" in settlement
          ? settlement.snapshot?.departure?.contractId
          : undefined)
      : undefined;
  const isDeparture = !!departureContractId;
  const departureGroupId = isDeparture ? parentGroupId : undefined;

  const { units: realGroupUnits } = useGroupUnits(
    settlement?.scope === "group" ? settlement.groupId : departureGroupId,
  );

  // For a group-scope settlement the fetch still spans the units — not for
  // their own costs (those settle on the unit) but for legacy pre-split
  // group-cost children, which carry a groupCostRef and live on the units.
  // Archived units included: what the settlement splits over is decided
  // further down (settledUnits), once its period is known.
  const unitIds =
    settlement?.scope === "group"
      ? realGroupUnits.map(u => String(u.id))
      : undefined;
  const filter =
    settlement?.scope === "group"
      ? { groupId: settlement.groupId, unitIds }
      : { unitId: settlement?.unitId, parentGroupId: departureGroupId };

  const {
    items: fetchedInvoices,
    refetch: refetchInvoices,
    isLoading: isLoadingInvoices,
    loadFailed: invoicesLoadFailed,
    reload: reloadInvoices,
  } = useInvoices(filter);
  // A building settlement takes everything (2026-10-16): the building's own
  // costs and every unit's own costs (see wizardSettlementCosts). A cost
  // created on the group before creation always stamped scope=common may
  // still say "private": it is read as a common cost, as the confirmed view
  // reads it, so its keys match the snapshot. Read here, right after the
  // fetch, so auto-select, the engine input and every step see one list.
  const toWizardCosts = (fetched: Invoice[]): Invoice[] =>
    wizardSettlementCosts({
      fetched,
      scope: settlement?.scope,
      groupId: settlement?.groupId,
      departureGroupId,
    });
  const invoices = useMemo(
    () => toWizardCosts(fetchedInvoices),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [fetchedInvoices, settlement?.scope, settlement?.groupId, departureGroupId],
  );
  const { rentals: unitRentals, isLoaded: areUnitRentalsLoaded } =
    usePropertyRentalContractsState(
      settlement?.scope === "unit" && settlement.unitId
        ? Number(settlement.unitId)
        : undefined,
    );
  const groupRentals = useGroupRentalContracts(
    settlement?.scope === "group" ? realGroupUnits.map(u => u.id) : [],
  );
  const rentals = settlement?.scope === "group" ? groupRentals : unitRentals;
  // Which slices of the tenant's provision this settlement weighs (see
  // settlementSlicesFor): a building both, an interim settlement of a unit
  // inside a building only the private one, a unit on its own and a
  // departure both. Each month of each slice is settled once per lease.
  const unitInGroup =
    settlement?.scope === "unit" && settlement.unitId
      ? settledProperties.find(p => p.id === settlement.unitId)?.parentId !=
        null
      : false;
  // The provision's history over every day this settlement could count: from
  // the earliest contract start or cost period up to today or the latest cost
  // period. Wide on purpose — the broker can still change the settlement
  // period in the wizard, and a cost's own period may reach beyond it.
  const historyRange = useMemo(() => {
    const today = todayIsoDay();
    const days = [
      today,
      settlement?.periodFrom,
      settlement?.periodTo,
      ...invoices.flatMap(i => [i.periodFrom, i.periodTo]),
      ...rentals.map(r => r.ref.startDate),
    ].filter((d): d is string => !!d && d < "2999-01-01");
    const sorted = [...days].sort();
    return { from: sorted[0], to: sorted[sorted.length - 1] };
  }, [settlement?.periodFrom, settlement?.periodTo, invoices, rentals]);
  const provisionSchedules = useProvisionSchedules({
    propertyId: Number(settlement?.unitId ?? settlement?.groupId ?? 0),
    contractIds: rentals.map(r => r.ref.id),
    from: historyRange.from,
    to: historyRange.to,
  });
  const provisionSlices: ProvisionSlice[] = settlementSlicesFor({
    scope: settlement?.scope ?? "unit",
    unitInGroup,
    isDeparture,
  });
  // The monthly provision and the flat-rate flag of the slices it weighs.
  const contracts = useMemo(
    () =>
      rentals.map(r => ({
        ...withSettlementSlices(r.ref, provisionSlices),
        provisionSchedule: provisionSchedules?.[r.ref.id],
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      settlement?.scope,
      unitInGroup,
      isDeparture,
      groupRentals,
      unitRentals,
      provisionSchedules,
    ],
  );
  // The payer the broker chose in "Verwerking" for a lease with several
  // tenants or a parent, by contract id.
  const [payerChoiceByContract, setPayerChoiceByContract] = useState<
    Record<string, number>
  >({});
  // contractId → payer + unit, for creating the payment orders in the
  // in-flow "Betaalopdrachten" step. `payerId` is undefined while the broker
  // still has to choose; `guessPayerId` is the first tenant, only good
  // enough to pick the statement's language.
  const rentalByContractId = useMemo(() => {
    const out: Record<
      string,
      {
        payerId?: number;
        guessPayerId?: number;
        payerCandidates: IPayerCandidate[];
        unitId: string;
        leaseChargesVat?: boolean;
      }
    > = {};
    for (const r of rentals) {
      const payerCandidates = r.ref.payerCandidates ?? [];
      out[r.ref.id] = {
        payerId: getEffectivePayerId({
          candidates: payerCandidates,
          chosenId: payerChoiceByContract[r.ref.id],
        }),
        guessPayerId: r.tenantAccountId,
        payerCandidates,
        unitId: r.ref.unitId,
        leaseChargesVat: r.ref.leaseChargesVat,
      };
    }
    return out;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settlement?.scope, groupRentals, unitRentals, payerChoiceByContract]);
  const { items: keys } = useKeys(
    settlement?.groupId ?? departureGroupId ?? "",
  );
  const {
    items: allSettlements,
    isLoading: isLoadingAllSettlements,
    loadFailed: allSettlementsLoadFailed,
    refetch: refetchAllSettlements,
  } = useSettlements(
    settlement?.scope === "group"
      ? { groupId: settlement.groupId, unitIds }
      : {
          unitId: settlement?.unitId,
          unitIds: parentGroupId ? [parentGroupId] : [],
        },
  );
  // Without its costs, or without the settlements already made (which hold
  // the costs and provision months settled before), the settlement would be
  // calculated on an incomplete list — no costs at all refunded every
  // provision. It cannot go past its period until a retry loads them.
  const dataLoadFailed = invoicesLoadFailed || allSettlementsLoadFailed;
  const handleRetryLoad = () => {
    refetchInvoices();
    refetchAllSettlements();
  };

  // Costs belonging to the parent group, surfaced in a unit settlement for
  // context only: they are shown, never selectable, and never calculated.
  const groupOnlyInvoiceIds = useMemo(() => {
    const ids = new Set<string>();
    if (settlement?.scope !== "unit" || !settlement.unitId) return ids;
    // A departure settlement takes the group's costs too.
    if (isDeparture) return ids;
    for (const inv of invoices) {
      if (String(inv.unitId) !== String(settlement.unitId)) ids.add(inv.id);
    }
    return ids;
  }, [invoices, settlement?.scope, settlement?.unitId, isDeparture]);

  // Costs already locked into a confirmed settlement — can't be settled again.
  const settledInvoiceIds = useMemo(() => {
    const ids = new Set<string>();
    for (const s of allSettlements) {
      // A departure settlement leaves the rest of its costs open.
      if (
        s.status === "confirmed" &&
        s.id !== ownId &&
        s.snapshot &&
        !isDepartureSettlement(s)
      ) {
        for (const id of s.snapshot.invoiceIds) ids.add(id);
      }
    }
    return ids;
  }, [allSettlements, ownId]);
  // The departure corrections confirmed settlements made (decision 3): a
  // departure is corrected once.
  const confirmedCorrections = useMemo(
    () =>
      allSettlements.flatMap(s =>
        s.status === "confirmed" && s.id !== ownId
          ? s.snapshot?.departureCorrections ?? []
          : [],
      ),
    [allSettlements, ownId],
  );
  // The same, by the settlement that made them, the one shown included: a
  // departure they corrected says where (M28).
  const correctionsBySettlement = useMemo(
    () =>
      confirmedCorrectionsBySettlement({
        settlements: allSettlements,
        nameOf: settlementDisplayName,
      }),
    [allSettlements],
  );
  // Each lease's rows in those settlements: the lease end each settled it
  // up to (decision 3).
  const settledRows = useMemo(
    () => settledLeaseRows({ settlements: allSettlements, ownId }),
    [allSettlements, ownId],
  );

  // Where each of those costs was settled, as the cost choice names it (see
  // settledInLabels).
  const settledInLabelsByCost = useMemo(
    () =>
      settledInLabels({
        settlements: allSettlements,
        ownId,
        unitLabelOf: unitId => {
          const unit = assignable.find(p => p.id === unitId);
          return unit ? unitAddressLabel(unit) : undefined;
        },
        buildingLabelOf: groupId =>
          buildingSectionTitle(
            buildingAddressOf(assignable.find(p => p.id === groupId)),
          ),
      }),
    [allSettlements, ownId, assignable],
  );

  // Provision months each contract already settled in an earlier confirmed
  // settlement in the property tree, per slice of the provision (see
  // settledProvisionsInTree).
  const settledProvisions = useMemo(
    () =>
      settledProvisionsInTree({
        settlements: settlement ? allSettlements : [],
        ownId,
        scope: settlement?.scope ?? "unit",
        unitInGroup,
        contracts,
        invoices,
        nameOf: settlementDisplayName,
      }),
    [allSettlements, ownId, settlement, contracts, invoices, unitInGroup],
  );
  const settledProvisionIntervals = settledProvisions.byContract;
  // The provision lines an earlier settlement left out (decision 14).
  const openProvisionLines = settledProvisions.openLines;

  // One set for every "cannot be settled here" reason, so auto-select, the
  // engine input and the confirm step can never drift apart. Keyed on its ids,
  // not on the sets above: those are rebuilt from store lists that are new
  // arrays on every render, and an effect keyed on them then ran every render.
  const excludedIdsKey = getIdSetKey([
    ...settledInvoiceIds,
    ...groupOnlyInvoiceIds,
  ]);
  const excludedInvoiceIds = useMemo(
    () => getIdSetFromKey(excludedIdsKey),
    [excludedIdsKey],
  );

  const [draft, setDraft] = useState<SettlementDraftState | null>(null);
  // The latest draft, also between a save and the render it causes, so two
  // saves in a row build on each other instead of on the draft of an older
  // render.
  const latestDraftRef = useRef<SettlementDraftState | null>(null);
  latestDraftRef.current = draft;
  // Final "Opslaan" step: does the user want to create payment orders for the
  // tenants with an outstanding balance? When yes, per-tenant payment steps are
  // appended to this same wizard instead of redirecting after save.
  const [createPayments, setCreatePayments] = useState(true);
  // Guards the final save: a second click while the API call is in flight
  // would create a SECOND settlement, and a silent failure left the broker
  // unsure whether anything was stored at all.
  const [isSaving, setIsSaving] = useState(false);
  // The state above only disables the button after a re-render; this ref also
  // stops a second click that lands before it.
  const isSavingRef = useRef(false);
  // The costs the broker confirmed, and what changed in them once the server
  // refused that confirm because another tab paid, billed, edited or deleted
  // one meanwhile: shown on "Keuze van kosten" until they leave it.
  const reviewedCostsRef = useRef<Invoice[]>([]);
  const [changedCosts, setChangedCosts] = useState<IReviewedCostsDiff | null>(
    null,
  );

  // Embedded per-tenant payment flow (mirrors the cost InvoiceModal): a stable
  // formId + ref drive the inner MultiStepForm from the wizard's own footer.
  const reduxStore = useStore();
  const paymentFormId = useRef(generateFormId());
  const paymentFormRef = useRef<any>(null);
  const [paymentSchemaCount, setPaymentSchemaCount] = useState(0);
  const [innerStepIndex, setInnerStepIndex] = useState(0);
  // Visible sub-steps of the embedded payment flow (reported by the form) so
  // the wizard's own left-hand navigation can mirror them.
  const [innerSteps, setInnerSteps] = useState<
    { title: string; rawIndex: number }[]
  >([]);
  const [innerVisibleIndex, setInnerVisibleIndex] = useState(0);
  // Multiple owing tenants: fill the payment details once for all ("bulk") or
  // step through the payment flow once per tenant. Either way every tenant ends
  // up with their own payment order + open payment on their own pand.
  const [paymentMode, setPaymentMode] = useState<"bulk" | "perTenant">("bulk");
  const [payIndex, setPayIndex] = useState(0);
  // "Alles in één keer per eigenaar": the form showing, among ownerPayRuns.
  const [payRunIndex, setPayRunIndex] = useState(0);
  // Order ids known before a payment step opens; the diff after it submits is
  // the order that step created. Collected per contract, baked into the
  // snapshot at the final save.
  const knownOrderIdsRef = useRef<number[]>([]);
  const orderByContractRef = useRef<Record<string, number>>({});
  // contractId → that tenant's own payment request under the (shared) order.
  const requestByContractRef = useRef<Record<string, number>>({});
  // contractId → who that tenant's order bills, by name (see
  // getOrderPayerNames).
  const orderPayerNameByContractRef = useRef<Record<string, string>>({});
  // "Versturen" creates the payment orders once. Redux only marks the create
  // as pending after a re-render, so a double click used to bill every tenant
  // twice. The lock is set on the click itself and released by a failure or
  // by the next tenant's form; after the last success it stays on until the
  // wizard has left.
  const paymentSubmitLockRef = useRef(false);
  const [isPaymentSubmitLocked, setIsPaymentSubmitLocked] = useState(false);
  const isSubmittingPayment = useSelector(
    isPerformingSubmitActionSelector(undefined, true),
  );

  useEffect(() => {
    if (settlement?.draftState && !draft) setDraft(settlement.draftState);
  }, [settlement, draft]);

  // In new mode the virtual settlement's draftState is authoritative until
  // materialization; seed the local draft from it once.
  useEffect(() => {
    if (isNewMode && virtualSettlement?.draftState && !draft) {
      setDraft(virtualSettlement.draftState);
    }
  }, [isNewMode, virtualSettlement, draft]);

  // Auto-select invoices that overlap the period on first load, once the
  // confirmed settlements are in (an already settled cost is never proposed).
  // A functional update on the current draft: the updater leaves it untouched
  // when there is nothing to select, and never overwrites a period or a
  // selection the broker changed in the meantime.
  const hasDraft = draft != null;
  useEffect(() => {
    if (!hasDraft || !invoices.length || isLoadingAllSettlements) return;
    setDraft(current =>
      withAutoSelectedInvoices({
        draft: current,
        invoices,
        excludedInvoiceIds,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasDraft, invoices.length, excludedInvoiceIds, isLoadingAllSettlements]);

  // The periods the confirmed settlements of the tree already settled (not
  // a departure's): a cost of such a period that came in later is offered
  // (decision 11), and a new settlement proposes a period after them (M22).
  const settledPeriods = useMemo(
    () =>
      allSettlements
        .filter(
          s =>
            s.status === "confirmed" &&
            s.id !== ownId &&
            !isDepartureSettlement(s),
        )
        .map(s => ({
          name: settlementDisplayName(s),
          from: s.periodFrom,
          to: s.periodTo,
          // Only a settlement whose scope took a cost makes it late (M16).
          scope: s.scope,
          unitId: s.unitId,
        })),
    [allSettlements, ownId],
  );

  // A new settlement opened on last year, before its costs and the
  // settlements already made were known (M22): once they are, and while the
  // broker has not touched the period or the name, it moves to the year of
  // the open costs after the settled ones (proposeSettlementPeriod), and a
  // period that overlaps a confirmed settlement is named "Aanvulling …".
  const isPeriodProposedRef = useRef(false);
  useEffect(() => {
    if (!isNewMode || isDeparture || isPeriodProposedRef.current) return;
    const awaitsCosts = isLoadingInvoices && !invoicesLoadFailed;
    if (!hasDraft || isLoadingAllSettlements || awaitsCosts) return;
    isPeriodProposedRef.current = true;
    const initial = defaultLastYearPeriod();
    const period = proposeSettlementPeriod({
      invoices,
      excludedInvoiceIds,
      settledPeriods,
      today: todayIsoDay(),
    });
    const isSupplementary =
      overlappingSettlementNames({ period, settledPeriods }).length > 0;
    setDraft(current => {
      if (
        !current ||
        current.name !== undefined ||
        (current.stepIndex ?? 0) > 0 ||
        current.period.from !== initial.from ||
        current.period.to !== initial.to
      ) {
        return current;
      }
      if (period.from === initial.from && period.to === initial.to) {
        return isSupplementary === !!current.isSupplementary
          ? current
          : { ...current, isSupplementary };
      }
      return {
        ...current,
        period,
        isSupplementary,
        selectedInvoiceIds: getAutoSelectedInvoiceIds({
          invoices,
          excludedInvoiceIds,
          period,
        }),
      };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isNewMode,
    isDeparture,
    hasDraft,
    isLoadingAllSettlements,
    isLoadingInvoices,
    invoicesLoadFailed,
  ]);

  // A departure settlement runs over the leaving lease, up to its last day
  // ("Eindafrekening bij vertrek", see getSettlementTitle), from the day
  // after the last settlement in Rentio that covered it, else from the
  // lease's start, never more than five years back (D8, see
  // departureDefaultStart). Set once the lease, its costs and the
  // settlements already made are known, before the broker changed anything;
  // the costs of that period are proposed again, except the ones waiting for
  // the readings of the year (see awaitsYearlyReadings).
  const departureLease = contracts.find(c => c.id === departureContractId);
  // The lease end a saved departure draft ran to before it followed the
  // lease's new end (M11): the wizard says so until the settlement is saved.
  const [movedLeaseEnd, setMovedLeaseEnd] = useState<
    { from: string; to: string } | undefined
  >();
  useEffect(() => {
    // A failed cost fetch never ends loading; the wizard then waits for a
    // retry before it goes past the period anyway (dataLoadFailed).
    const awaitsCosts = isLoadingInvoices && !invoicesLoadFailed;
    if (!departureLease || isLoadingAllSettlements || awaitsCosts) return;
    const { from } = departureDefaultStart({
      leaseStart: departureLease.startDate,
      departureDay: departureLease.endDate,
      lastSettledDay: lastSettledDayOfLease({
        lease: departureLease,
        settledBySlice: settledProvisionIntervals[departureLease.id],
        settlements: allSettlements,
        ownId,
      }),
      today: todayIsoDay(),
    });
    // A saved draft whose lease end moved since follows the new end (M11),
    // until the settlement is confirmed: then it is frozen.
    const before = latestDraftRef.current?.departure?.until;
    if (
      before &&
      ownSavedId == null &&
      before.slice(0, 10) !== departureLease.endDate.slice(0, 10)
    ) {
      setMovedLeaseEnd({ from: before, to: departureLease.endDate });
      setDraft(current => {
        if (!current?.departure) return current;
        const moved = withDepartureLeaseEnd({
          draft: current,
          leaseEnd: departureLease.endDate,
          defaultFrom: from,
        });
        return moved === current
          ? current
          : withAutoSelectedInvoices({
              draft: moved,
              invoices,
              excludedInvoiceIds,
            });
      });
      return;
    }
    setDraft(current => {
      if (!current || current.departure) return current;
      return withAutoSelectedInvoices({
        draft: {
          ...current,
          departure: {
            contractId: departureLease.id,
            until: departureLease.endDate,
          },
          period: { from, to: departureLease.endDate },
          selectedInvoiceIds: {},
        },
        invoices,
        excludedInvoiceIds,
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    departureLease?.id,
    departureLease?.endDate,
    isLoadingAllSettlements,
    isLoadingInvoices,
    invoicesLoadFailed,
    invoices.length,
    hasDraft,
  ]);

  // Up to when Rentio already settled the leaving lease, and where (Y05,
  // Y06): the period step names it, and a lease settled up to its last day
  // may get a final settlement of € 0.
  const departureSettled = useMemo(
    () =>
      departureLease
        ? leaseSettledThrough({
            lease: departureLease,
            lastSettledDay: lastSettledDayOfLease({
              lease: departureLease,
              settledBySlice: settledProvisionIntervals[departureLease.id],
              settlements: allSettlements,
              ownId,
            }),
            settlements: allSettlements,
            ownId,
            nameOf: settlementDisplayName,
          })
        : undefined,
    [departureLease, settledProvisionIntervals, allSettlements, ownId],
  );

  // Nothing is stored before the final save, so leaving a new settlement
  // halfway loses the broker's input: every way out asks first. The save's
  // own redirect passes, since savedSettlementRef is set before it navigates.
  useLeaveGuard({
    when: hasUnsavedWizardInput({
      isNewMode,
      isSaved: ownSavedId != null,
      draft,
    }),
    isLeaveAllowed: () => savedSettlementRef.current != null,
  });
  // Leaving once saved asks nothing, so on its way out the wizard stores
  // what it could not store yet (see storePendingLinks).
  const storeOnLeaveRef = useOnUnmount();

  // The group's units this settlement splits over: the active ones and those
  // archived on or after its first day (its period start, or an earlier start
  // of one of its costs). A unit archived since keeps its key weight, its
  // tenants and its owner's vacancy for the time it existed; dropping it
  // shifted its share onto the other units' tenants. A unit archived before
  // takes no part, and neither do its leases.
  const settledUnitsFrom = earliestDay([
    draft?.period.from,
    ...invoices
      .filter(
        i => draft?.selectedInvoiceIds[i.id] && !excludedInvoiceIds.has(i.id),
      )
      .map(i => i.periodFrom),
  ]);
  const settledUnits = useMemo(
    () => unitsExistingSince({ units: realGroupUnits, from: settledUnitsFrom }),
    [realGroupUnits, settledUnitsFrom],
  );
  const settledUnitIds = useMemo(
    () =>
      settlement?.scope === "group" || departureGroupId
        ? settledUnits.map(u => String(u.id))
        : undefined,
    [settlement?.scope, departureGroupId, settledUnits],
  );
  // When each of those units was archived: a cost that began after that day
  // is not split over it, even when another cost reaches back further.
  const unitArchivedOn = useMemo(
    () =>
      Object.fromEntries(
        settledUnits.flatMap(u =>
          u.archivedOn ? [[String(u.id), u.archivedOn]] : [],
        ),
      ),
    [settledUnits],
  );
  const settledContracts = useMemo(() => {
    if (settlement?.scope !== "group") return contracts;
    const ids = new Set(settledUnitIds);
    return contracts.filter(c => ids.has(String(c.unitId)));
  }, [settlement?.scope, contracts, settledUnitIds]);

  // The owner of every pand in this settlement (all units of a group, vacant
  // ones included): the owner part is settled per owner, and a payment may
  // only go "all at once" when every owing tenant's pand has the same owner.
  const ownerUnitIds = useMemo(
    () =>
      settlement?.scope === "group"
        ? [
            ...new Set([
              ...(settledUnitIds ?? []),
              ...settledContracts.map(c => String(c.unitId)),
            ]),
          ]
        : settlement?.unitId
          ? [String(settlement.unitId)]
          : [],
    [settlement?.scope, settlement?.unitId, settledUnitIds, settledContracts],
  );
  const owners = usePropertyOwners(ownerUnitIds.map(Number));
  const ownerKeyByUnit = useMemo(
    () =>
      Object.fromEntries(
        ownerUnitIds.map(u => [u, owners.keyByProperty[Number(u)] ?? ""]),
      ),
    [ownerUnitIds, owners.keyByProperty],
  );

  // What departure settlements on the settled unit or units already settled
  // (see departuresInScope), also when the departed lease was deleted since.
  // A departure settlement itself settles its lease on its own, whatever
  // another lease's departure did.
  const departures = useMemo(
    () =>
      departuresInScope({
        settlements: allSettlements,
        ownId,
        scope: settlement?.scope,
        unitId: settlement?.unitId,
        settledUnitIds,
        isDeparture,
      }),
    [
      allSettlements,
      ownId,
      settlement?.scope,
      settlement?.unitId,
      settledUnitIds,
      isDeparture,
    ],
  );

  // What those departures froze, per cost, for the cost choice.
  const departureShares = useMemo(
    () => departureSharesByCost({ departures, settlements: allSettlements }),
    [departures, allSettlements],
  );

  const result = useMemo(() => {
    if (!draft) return null;
    // Never settle a cost that's already locked into a confirmed settlement.
    const cleanedDraft: SettlementDraftState = {
      ...draft,
      selectedInvoiceIds: Object.fromEntries(
        Object.entries(draft.selectedInvoiceIds).filter(
          ([id, on]) => on && !excludedInvoiceIds.has(id),
        ),
      ),
    };
    // Contracts with the provision toggle turned off are handled by the engine
    // itself (draft.provisionsIncluded).
    return computeResult({
      contracts: settledContracts,
      invoices,
      keys,
      draft: cleanedDraft,
      // All group units (incl. vacant ones) so a vacant unit's share of a
      // common cost falls on the owner instead of inflating the tenants.
      unitIds: settledUnitIds,
      unitArchivedOn,
      settledProvisionIntervals,
      openProvisionLines,
      // A unit without a building: one balance per tenant (decision 6).
      isStandaloneUnit: settlement?.scope === "unit" && !unitInGroup,
      // What a departure whose lease end moved needs corrected (decision 3).
      settledElsewhereInvoiceIds: [...settledInvoiceIds],
      confirmedCorrections,
      settledRows,
      ownerKeyByUnit,
      departureContractId,
      departures,
    });
  }, [
    settledContracts,
    invoices,
    keys,
    draft,
    excludedInvoiceIds,
    settledUnitIds,
    unitArchivedOn,
    settledProvisionIntervals,
    openProvisionLines,
    settlement?.scope,
    unitInGroup,
    settledInvoiceIds,
    confirmedCorrections,
    settledRows,
    ownerKeyByUnit,
    departureContractId,
    departures,
  ]);

  // Statements are rendered in the recipient's language: each tenant's own,
  // and for an owner statement that owner's (first account's) language.
  const firstOwnerAccount = (ownerKey: string) =>
    Number(ownerKey.split(",")[0] || 0);
  const ownerKeys = [...new Set(Object.values(ownerKeyByUnit))];
  // The office of the settled property sends every statement (Lewis,
  // 2026-10-19): its name and address, from its own account's contact.
  const officeBrokerId = settledProperties.find(
    p => p.id === String(settlement?.groupId ?? settlement?.unitId ?? ""),
  )?.brokerId;
  const { detail: officeBroker } = brokerHooks.useDetail({
    id: officeBrokerId,
    shouldRefetch: false,
  });
  // Every possible payer's language is fetched, so a payer the broker picks
  // in "Verwerking" gets the statement in their own language; with it every
  // party's postal address.
  const accountContacts = useAccountContacts([
    ...Object.values(rentalByContractId).flatMap(r =>
      r.payerCandidates.map(candidate => candidate.accountId),
    ),
    ...Object.values(rentalByContractId).map(r => r.guessPayerId ?? 0),
    ...ownerKeys.map(firstOwnerAccount),
    officeBroker?.accountId ?? 0,
  ]);
  const localeOfAccount = (accountId: number) =>
    accountContacts[accountId]?.locale;
  const statementAddresses: IStatementAddresses = {
    office: statementOfficeOf({
      broker: officeBroker,
      contact:
        officeBroker?.accountId != null
          ? accountContacts[officeBroker.accountId]
          : undefined,
    }),
    byContractId: Object.fromEntries(
      Object.entries(rentalByContractId).map(([contractId, r]) => [
        contractId,
        leasePostalAddress({
          candidates: r.payerCandidates,
          addressOf: accountId => accountContacts[accountId]?.address,
          // The letter's language is the payer's too (statementLocales).
          payerId: r.payerId ?? r.guessPayerId,
        }),
      ]),
    ),
    ownerByKey: Object.fromEntries(
      ownerKeys.map(k => [k, accountContacts[firstOwnerAccount(k)]?.address]),
    ),
  };
  const statementLocales = {
    ownerByKey: Object.fromEntries(
      ownerKeys.map(k => [k, localeOfAccount(firstOwnerAccount(k))]),
    ) as Record<string, string | undefined>,
    byContractId: Object.fromEntries(
      Object.entries(rentalByContractId).map(([contractId, r]) => {
        const localePayerId = r.payerId ?? r.guessPayerId;
        return [
          contractId,
          localePayerId != null ? localeOfAccount(localePayerId) : undefined,
        ];
      }),
    ) as Record<string, string | undefined>,
  };

  if (!settlement) return <Loading />;

  // A departure wizard opened for a lease that already has a confirmed
  // departure settlement, or that is not a lease of this unit (an old link,
  // another tab), says so instead of preparing a departure the API refuses
  // on confirm. Only before this wizard saved its own departure, and once
  // the leases and the settlements have loaded.
  const departureBlock: TDepartureBlock | undefined =
    isNewMode &&
    virtualScope?.departureContractId &&
    !ownSavedId &&
    !savedSettlementRef.current &&
    areUnitRentalsLoaded &&
    !isLoadingAllSettlements &&
    !allSettlementsLoadFailed
      ? departureBlockOf({
          contractId: virtualScope.departureContractId,
          contracts: unitRentals.map(rental => rental.ref),
          settlements: allSettlements,
          ownId,
        })
      : undefined;
  if (departureBlock) {
    const costsUrl = `/properties/${settlement.unitId}/costs`;
    return (
      <Card>
        <Stack vertical spacing="loose">
          <Banner variation="warning" hasDismiss={false}>
            {departureBlock.kind === "exists"
              ? getLocalizedText("settlement.departure.already_settled", {
                  name: settlementDisplayName(departureBlock.settlement),
                })
              : getLocalizedText("settlement.departure.not_on_unit")}
          </Banner>
          <ButtonGroup align="left">
            <Button
              appearance="primary"
              onClick={() =>
                navigate(
                  departureBlock.kind === "exists"
                    ? `${costsUrl}?settlementId=${departureBlock.settlement.id}`
                    : costsUrl,
                )
              }
            >
              {getLocalizedText(
                departureBlock.kind === "exists"
                  ? "settlement.departure.open_existing"
                  : "costs.back_to_costs",
              )}
            </Button>
          </ButtonGroup>
        </Stack>
      </Card>
    );
  }

  // A confirmed settlement has no draftState — render the frozen view directly
  // (don't wait on draft/result, which never resolve once confirmed).
  if (settlement.status === "confirmed") {
    return (
      <ConfirmedView
        settlement={settlement}
        invoices={invoices}
        isLoadingInvoices={isLoadingInvoices}
        invoicesLoadFailed={invoicesLoadFailed}
        onRetryInvoices={refetchInvoices}
        contracts={contracts}
        keys={keys}
        assignable={settledProperties}
        statementLocales={statementLocales}
        statementAddresses={statementAddresses}
        // The view explains a refused write in a dialog of its own, and
        // reads the settlement again either way, so it shows what is stored.
        persistActions={async actions => {
          try {
            await recordActions(actions);
          } finally {
            refetchSettlement();
          }
        }}
        reloadSettlement={reloadSettlement}
        readOnly={readOnly}
        treeCorrections={correctionsBySettlement}
      />
    );
  }

  if (!draft || !result) return <Loading />;
  // Wait for the provision history: confirming on the fallback estimate while
  // it is still loading would freeze the wrong expected provisions.
  if (provisionSchedules === null) return <Loading />;
  // Whether a unit sits in a group decides which provision slice it settles;
  // before the property list (and an archived unit's own lookup) is in, it
  // would count the full provision.
  if (
    settlement.scope === "unit" &&
    isResolvingSettledProperty &&
    !settledProperties.some(p => p.id === settlement.unitId)
  ) {
    return <Loading />;
  }

  // A departure settlement splits the group's costs by key like a group.
  const baseSteps: StepDef[] =
    settlement.scope === "group" || departureGroupId
      ? stepsGroup()
      : stepsUnit();
  // Tenants with an outstanding balance. When the user opts in, they all get a
  // payment order in ONE embedded payment flow (a single "Betaalopdrachten"
  // step, not one per tenant) — the payment form fans out an order per split.
  // Costs actually going into this settlement — drives the payment amounts, the
  // VAT rates below and the step context.
  const selected = invoices.filter(
    i =>
      draft.selectedInvoiceIds[i.id] &&
      settlementEligible(i) &&
      !excludedInvoiceIds.has(i.id),
  );

  // VAT rates per category, to turn the engine's excl-btw balance into the
  // VAT-inclusive amount an invitation actually bills.
  // Plain call, not useMemo: this sits after the component's early returns, so a
  // hook here would break hook order. The map is a single pass over the selected
  // costs.
  const payCatMeta = buildCatMeta(selected);

  // The properties with the archived units this settlement still counts: the
  // wizard marks them, the statements name their address only.
  const wizardAssignable = withArchivedUnits({
    properties: assignable,
    units: settledUnits,
    groupId: settlement.groupId,
    marked: true,
  });
  const statementAssignable = withArchivedUnits({
    properties: assignable,
    units: settledUnits,
    groupId: settlement.groupId,
    marked: false,
  });

  // Who gets a payment order is decided on the VAT-INCLUSIVE amount — the
  // number that is actually billed. Filtering on the engine's excl-btw balance
  // skipped tenants whose provision covered the excl amount but not the VAT.
  const payTenants = result.perContract.filter(
    pc => tenantOwedInclVat(pc, payCatMeta).incl > MIN_PAYABLE_AMOUNT,
  );
  // Once saved, the settlement is final: the steps before "Verwerking" are
  // locked and every payment bills the frozen amounts of the saved snapshot,
  // never the live calculation (which could still drift from it).
  const isSaved = ownSavedId != null;
  const savedSnapshot = savedSettlementRef.current?.snapshot;
  const owingTenants: IOwingTenant[] =
    isSaved && savedSnapshot
      ? getOwingTenantsFromSnapshot(savedSnapshot)
      : payTenants.map(pc => ({
          contractId: pc.contractId,
          tenantName: pc.tenantName,
          amount: tenantOwedInclVat(pc, payCatMeta).incl,
        }));
  const confirmIndex = baseSteps.length;
  const hasPaymentsStep = createPayments && owingTenants.length > 0;
  const steps: StepDef[] = [
    ...baseSteps,
    { key: "confirm", title: getLocalizedText("settlement.step.processing") },
    ...(hasPaymentsStep
      ? [
          {
            key: "payments",
            title: getLocalizedText("settlement.step.payment_orders"),
          },
        ]
      : []),
  ];
  // A saved settlement never shows its editable steps again, whatever index
  // the draft still holds.
  const stepIndex = Math.min(
    isSaved
      ? Math.max(draft.stepIndex ?? 0, confirmIndex)
      : draft.stepIndex ?? 0,
    steps.length - 1,
  );

  // Splits for the bulk payment form: one per tenant that owes, each on its own
  // unit with its own payer. The amount is the VAT-INCLUSIVE balance: the
  // engine's `pc.balance` is excl. btw, and billing that would charge the
  // tenant less than the Samenvatting, the statement and the confirmed view's
  // own invitation all show.
  // The payer is the one frozen on confirm once saved, else the lease's rent
  // payer or the broker's choice in "Verwerking". The description is the
  // settlement's title, written in the payer's language.
  const payShares: IPayShare[] = owingTenants.map(owing => {
    const rental = rentalByContractId[owing.contractId];
    const unitId = rental?.unitId;
    const unitProp = wizardAssignable.find(p => p.id === unitId);
    const payerId = isSaved && savedSnapshot ? owing.payerId : rental?.payerId;
    return {
      ...owing,
      payerId,
      // Once billed, a lease whose payer the payment form asked for is named
      // after the payer its order went to.
      payerName:
        getPayerName({
          candidates: rental?.payerCandidates,
          accountId: payerId,
        }) ?? orderPayerNameByContractRef.current[owing.contractId],
      propertyId: Number(unitId ?? settlement.unitId ?? 0),
      // "Bouwlaan 10 bus 1, 9000 Gent", as the lists name it (M40).
      unitLabel: unitProp?.addressParts
        ? unitAddressLabel(unitProp)
        : unitProp?.address ?? unitProp?.code,
      description: getSettlementPaymentDescription({
        name: getDraftSettlementName(draft),
        kind: isDeparture ? "departure" : "regular",
        period: draft.period,
        locale: statementLocales.byContractId[owing.contractId],
      }),
    };
  });
  // Tenants on a VAT-taxable lease. Their payment bills the real costs with
  // the suppliers' VAT, like any lease, and no VAT of the lease: billing the
  // lease's VAT here would make the request differ from the statement, which
  // waits for the accountant's rules. "Verwerking" warns.
  const vatTaxableShares = payShares.filter(
    share => rentalByContractId[share.contractId]?.leaseChargesVat,
  );
  // Leases with several tenants or a parent, and no rent order that says
  // who pays: the broker chooses the payer in "Verwerking" before saving.
  const payerCandidateCount = (contractId: string) =>
    rentalByContractId[contractId]?.payerCandidates.length ?? 0;
  const payerChoiceShares = isSaved
    ? []
    : payShares.filter(share => payerCandidateCount(share.contractId) > 1);
  const isPayerMissing =
    createPayments && payerChoiceShares.some(share => share.payerId == null);
  // The tenants who do not have a payment order from this wizard yet. Going
  // back to "Verwerking" or retrying after a failure only ever bills these.
  const openShares = payShares.filter(
    s => orderByContractRef.current[s.contractId] == null,
  );
  const billedShares = payShares.filter(
    s => orderByContractRef.current[s.contractId] != null,
  );
  const needsPayments = createPayments && openShares.length > 0;

  // Walk the flow once per tenant only when the user asked for it; bulk creates
  // the same set of orders from a single submission.
  // "Alles in één keer" pays every tenant to ONE chosen beneficiary. When the
  // owing tenants' panden have different owners that would route one owner's
  // money to another (Lewis, 2026-10-05), so bulk is off then and the flow
  // runs per tenant, where the beneficiary is chosen per pand. The owner is
  // the pand's, not the contract's. It fails closed: while the owners load, or
  // for a pand whose owner is unknown, bulk stays off.
  const mixedOwners =
    !owners.loaded ||
    new Set(
      payShares.map(
        s => owners.keyByProperty[s.propertyId] || `unknown-${s.propertyId}`,
      ),
    ).size > 1;
  // A lease without any tenant or parent to bill has no payer: only its own
  // payment form can ask for one, so the flow runs per tenant then.
  const hasShareWithoutPayer = openShares.some(share => share.payerId == null);
  // Tenants of different owners: "Alles in één keer per eigenaar" bills each
  // owner's tenants in a form of their own, where the beneficiary is chosen
  // as in the one-owner form, and the tenants of a unit without an owner one
  // by one (see ownerPayGroups.utils). Once the owners are known.
  const ownerGroups = groupSharesByOwner({
    shares: payShares,
    propertyIdOf: share => share.propertyId,
    ownerKeyByProperty: owners.keyByProperty,
    nameByKey: owners.nameByKey,
  });
  const ownerPayRuns = getOwnerPayRuns(ownerGroups);
  const isPerOwnerOffered =
    owners.loaded &&
    mixedOwners &&
    !hasShareWithoutPayer &&
    payShares.length > 1 &&
    canPayPerOwner(ownerGroups);
  const payPerOwner = isPerOwnerOffered && paymentMode === "bulk";
  const payPerTenant =
    (paymentMode === "perTenant" ||
      (mixedOwners && !payPerOwner) ||
      hasShareWithoutPayer) &&
    payShares.length > 1;

  // A functional update: merged into this render's draft, a pending update
  // (the auto-select) was overwritten and the broker's click got lost.
  const saveDraft = async (partial?: Partial<SettlementDraftState>) => {
    const next = { ...(latestDraftRef.current ?? draft), ...partial };
    latestDraftRef.current = next;
    setDraft(current => (current ? { ...current, ...partial } : next));
    // Geen concepten: in new mode leeft de hele wizard in lokale state — er
    // wordt pas een DB-rij aangemaakt bij de finale Opslaan (doConfirm).
    if (isNewMode) return;
    await updateDraft({ draftState: next });
  };

  const invoicesStepIndex = steps.findIndex(step => step.key === "invoices");
  const setStep = (i: number) => {
    // What changed in the costs is shown until the broker leaves their step.
    if (i !== invoicesStepIndex) setChangedCosts(null);
    return saveDraft({ stepIndex: i });
  };

  const ctx = {
    settlement,
    draft,
    saveDraft,
    invoices,
    // A departure settlement shows its own lease only.
    contracts: isDeparture
      ? settledContracts.filter(c => c.id === departureContractId)
      : settledContracts,
    departureContractId,
    keys,
    units:
      settlement?.scope === "group" || departureGroupId
        ? settledUnits.map(u => ({
            id: String(u.id),
            code: u.label,
            address: unitDisplayLabel({
              label: u.address,
              archivedOn: u.archivedOn,
            }),
            archivedOn: u.archivedOn,
          }))
        : [],
    assignable: wizardAssignable,
    settledInvoiceIds: excludedInvoiceIds,
    settledInLabels: settledInLabelsByCost,
    departureSharesByCost: departureShares,
    settledProvisionIntervals,
    provisionsFromEarlierLeases: settledProvisions.fromEarlierLeases,
    provisionsSettledBy: settledProvisions.settledBy,
    openProvisionLines,
    departureSettled,
    departures,
    settledPeriods,
    // Its own corrections come from the engine (Step4Summary).
    confirmedCorrections: correctionsBySettlement.filter(
      c => c.settlementId !== ownId,
    ),
    // A building settlement takes its units' own costs and both slices.
    isBuildingSettlement: settlement.scope === "group",
    ownerNames: owners.nameByKey,
    ownerKeyByUnit,
    groupOnlyInvoiceIds,
    loadFailed: dataLoadFailed,
    onRetryLoad: handleRetryLoad,
  };

  const currentKey = steps[stepIndex].key;
  const isConfirmStep = currentKey === "confirm";
  const isPayStep = currentKey === "payments";

  // A departure whose lease ends more than six months from now (M17): the
  // notice is registered first, so the settlement runs to the real end. The
  // wizard warns from the start and does not confirm; the API refuses too.
  const isDepartureTooFarAhead =
    isDeparture &&
    !isSaved &&
    departureEndsTooFarAhead({
      leaseEnd: departureLease?.endDate,
      today: todayIsoDay(),
    });
  const departureTooFarAheadText = departureLease
    ? getLocalizedText("settlement.departure.lease_ends_later", {
        date: fmtDate(departureLease.endDate),
      })
    : undefined;

  let stepValid = true;
  // Human-readable reason why "Volgende" is disabled — shown next to the
  // footer so the user is never stuck on a silently disabled button.
  let stepInvalidReason: string | undefined;
  if (currentKey === "period") {
    const periodErrorKey = getPeriodStepErrorKey(
      getPeriodStepErrors({
        name: getDraftSettlementName(draft),
        period: draft.period,
        today: todayIsoDay(),
      }),
    );
    stepValid = !periodErrorKey;
    if (periodErrorKey) stepInvalidReason = getLocalizedText(periodErrorKey);
  }
  // No cost chosen: the broker first confirms that the period had none.
  if (currentKey === "invoices") {
    const invoicesErrorKey = getInvoicesStepErrorKey({
      chosenCount: selected.length,
      noCostsConfirmed: draft.noCostsConfirmed,
      isSettledThroughDeparture: !!departureSettled?.isFull,
    });
    stepValid = !invoicesErrorKey;
    if (invoicesErrorKey)
      stepInvalidReason = getLocalizedText(invoicesErrorKey);
  }
  // Nothing to settle: confirming would only lock an empty settlement.
  // A lease Rentio settled up to its last day already may get a final
  // settlement of € 0 that says so (Y06).
  const nothingToSettle =
    isNothingToSettle(result) && !departureSettled?.isFull;
  if (currentKey === "summary" && nothingToSettle) {
    stepValid = false;
    stepInvalidReason = getLocalizedText(
      "settlement.summary.nothing_to_settle_block",
    );
  }
  // No cost needed (Lewis, 2026-10-05): a settlement may only refund the
  // provisions of a year without costs.
  if (currentKey === "keys") {
    const validation = Step2Validate(ctx);
    stepValid = validation.ok;
    if (!validation.ok) stepInvalidReason = validation.reason;
  }
  // A saved settlement is frozen: only one still being made needs the lists.
  const isLoadBlocked = dataLoadFailed && !isSaved;
  if (isLoadBlocked && currentKey !== "period") {
    stepValid = false;
    stepInvalidReason = getLocalizedText("settlement.load_failed_block");
  }

  // A saved settlement is final: "Vorige" on "Verwerking" stays closed.
  const handlePrev = () => {
    if (isSaved) return;
    setStep(Math.max(0, stepIndex - 1));
  };
  const handleNext = async () => {
    // "Volgende" only advances the pre-confirm steps; the confirm step and the
    // per-tenant payment steps get their own footers below.
    return setStep(stepIndex + 1);
  };

  // Record the payment order ids that already exist so the diff after the bulk
  // payment step submits identifies the ones it created.
  const primeKnownOrderIds = () => {
    const state = (reduxStore.getState() as any)?.PAYMENT_ORDERS_V2;
    knownOrderIdsRef.current = state?.createPaymentOrders?.ids ?? [];
  };
  // Link the payment order(s) just created to the tenants they bill, see
  // linkCreatedOrders. The known ids move along, so the next diff only sees
  // orders created after these.
  const captureCreatedOrders = (shares: IPayShare[]) => {
    const state = (reduxStore.getState() as any)?.PAYMENT_ORDERS_V2;
    const ids: number[] = state?.createPaymentOrders?.ids ?? [];
    const detail = state?.detail ?? {};
    const createdOrderIds = ids.filter(
      id => !knownOrderIdsRef.current.includes(id),
    );
    knownOrderIdsRef.current = [
      ...knownOrderIdsRef.current,
      ...createdOrderIds,
    ];
    const links = linkCreatedOrders({
      shares,
      createdOrderIds,
      ordersById: detail,
    });
    Object.assign(orderByContractRef.current, links.orderByContract);
    Object.assign(requestByContractRef.current, links.requestByContract);
    Object.assign(
      orderPayerNameByContractRef.current,
      getOrderPayerNames({
        orderByContract: links.orderByContract,
        ordersById: detail,
      }),
    );
  };

  // A fresh payment form: a new id (the form keeps its answers per id) and the
  // mirrored sub-step state back at the start (onStepChange does not fire on
  // mount).
  const resetPaymentForm = () => {
    paymentFormId.current = generateFormId();
    setInnerStepIndex(0);
    setPaymentSchemaCount(0);
    setInnerSteps([]);
    setInnerVisibleIndex(0);
  };

  const lockPaymentSubmit = (isLocked: boolean) => {
    paymentSubmitLockRef.current = isLocked;
    setIsPaymentSubmitLocked(isLocked);
  };

  // "Versturen": submit the payment form once, see paymentSubmitLockRef.
  const handlePaymentSubmit = () => {
    const form = paymentFormRef.current;
    if (paymentSubmitLockRef.current || isSubmittingPayment) return;
    if (!form?.handlePressSubmit) return;
    lockPaymentSubmit(true);
    form.handlePressSubmit();
  };

  // A bulk submission creates the orders one tenant at a time. When a later one fails, the earlier ones exist anyway: link them to
  // the settlement, tell the broker who was billed, and reopen the form for
  // the remaining tenants only, so a retry never bills anyone twice.
  const handleBulkPaymentFailed = async (submitted: IPayShare[]) => {
    const state = (reduxStore.getState() as any)?.PAYMENT_ORDERS_V2;
    const createdGroupCount: number =
      state?.createPaymentOrders?.createdGroupCount ?? 0;
    if (createdGroupCount === 0) {
      lockPaymentSubmit(false);
      return;
    }
    const billed = submitted.slice(0, createdGroupCount);
    const missing = submitted.slice(createdGroupCount);
    captureCreatedOrders(billed);
    let isLinked = true;
    try {
      await linkPayments();
    } catch {
      isLinked = false;
    }
    // Named after who the orders bill (the payer), not the lease's tenants.
    confirmDialog({
      type: "warning",
      title: getLocalizedText("settlement.payments.partial_failure.title"),
      info: [
        getLocalizedText("settlement.payments.partial_failure.info", {
          billed: joinRecipientNamesAmong({ shares: billed, among: submitted }),
          missing: joinRecipientNamesAmong({
            shares: missing,
            among: submitted,
          }),
        }),
        ...(isLinked
          ? []
          : [getLocalizedText("settlement.payment_link_failed")]),
      ].join(" "),
    });
    resetPaymentForm();
    lockPaymentSubmit(false);
  };

  // Opens the payment flow from "Verwerking". The first time this confirms the
  // settlement; once saved it only reopens the flow for the tenants without a
  // payment order. No statement goes along: the office downloads and forwards
  // them itself (Lewis, 2026-10-20).
  const enterPaymentArea = async () => {
    await persistSettlement();
    // What an earlier save of this wizard failed to store is stored before
    // the payment steps open.
    await storePendingLinks();
    resetPaymentForm();
    setPayIndex(
      Math.max(
        0,
        getNextOpenShareIndex({
          shares: payShares,
          orderByContract: orderByContractRef.current,
          from: 0,
        }),
      ),
    );
    setPayRunIndex(
      Math.max(
        0,
        getNextOpenRunIndex({
          runs: ownerPayRuns,
          orderByContract: orderByContractRef.current,
          from: 0,
        }),
      ),
    );
    primeKnownOrderIds();
    setStep(confirmIndex + 1);
  };

  // "Verwerking" primary: open the payment flow when tenants still need a
  // payment order, otherwise save (or, once saved, leave).
  const handleConfirmPrimary = async () => {
    if (isSavingRef.current) return;
    // The Samenvatting already blocks this; never save an empty settlement.
    if (!isSaved && nothingToSettle) return;
    // The payer is frozen on save: it must be known before.
    if (isPayerMissing) return;
    if (isLoadBlocked) return;
    if (isDepartureTooFarAhead) return;
    isSavingRef.current = true;
    setIsSaving(true);
    try {
      // "Bezig met bevestigen…" shows before the statements are built: on a
      // big building that takes seconds, and the button looked dead
      // (decision 16 of 2026-10-20).
      if (!isSaved) await afterNextPaint();
      if (needsPayments) {
        await enterPaymentArea();
      } else if (isSaved) {
        await finishAfterPayments();
      } else {
        await doConfirm();
      }
    } catch (error) {
      if (isStaleCostsRefusal(error)) await showChangedCosts();
      // A departure confirmed or deleted meanwhile: the settlements are read
      // again, and the summary follows them.
      if (isDepartureChangedRefusal(error)) refetchAllSettlements();
      showSaveFailed(error);
    } finally {
      isSavingRef.current = false;
      setIsSaving(false);
    }
  };

  // Every statement document of this settlement: one per tenant and one per
  // owner. Built from the wizard's own result and frozen into the snapshot,
  // so a later download prints exactly what was confirmed.
  const buildAllStatements = (
    base: Settlement,
  ): Record<string, StatementSnapshot> => {
    const out: Record<string, StatementSnapshot> = {};
    const common = {
      settlement: base,
      name: getDraftSettlementName(draft),
      contracts: settledContracts,
      costs: selected,
      keys,
      selectedKeyId: draft.selectedKeyId,
      distribution: draft,
      assignable: statementAssignable,
      // The units the engine divided by, archived ones included.
      groupUnitIds:
        settlement.scope === "group"
          ? ownerUnitIds
          : isDeparture
            ? settledUnitIds
            : undefined,
      unitArchivedOn,
      landlordTotal: result.landlordTotal,
      isDeparture,
      // A building settlement prints its sections and provision slices.
      isBuildingSettlement: settlement.scope === "group",
      // The office sends every statement.
      office: statementAddresses.office,
    };
    for (const owner of result.owners) {
      out[`owner:${owner.ownerKey}`] = buildStatementSnapshot({
        ...common,
        mode: "owner",
        contract: null,
        provisionsExpected: 0,
        ownerResult: owner,
        alreadySettled: result.alreadySettled,
        ownerName: owners.nameByKey[owner.ownerKey],
        recipientAddress: statementAddresses.ownerByKey[owner.ownerKey],
        locale: statementLocales.ownerByKey[owner.ownerKey],
      });
    }
    for (const pc of result.perContract) {
      out[`tenant:${pc.contractId}`] = buildStatementSnapshot({
        ...common,
        mode: "tenant",
        contract: settledContracts.find(c => c.id === pc.contractId) ?? null,
        provisionsExpected: pc.provision,
        breakdown: pc.breakdown,
        breakdownVat: pc.breakdownVat,
        correctionProvisionByKey: pc.correctionProvisionByKey,
        extraProvisions: pc.extraProvisions,
        provisionBySlice: pc.provisionBySlice,
        provisionMonthsBySlice: pc.provisionMonthsBySlice,
        kinds: pc.kinds,
        fixedFeeKinds: pc.fixedFeeKinds,
        forfaitIntervalsBySlice: pc.forfaitIntervalsBySlice,
        vatByInvoice: pc.vatByInvoice,
        departure: departures.find(d => d.contractId === pc.contractId),
        costByInvoice: pc.costByInvoice,
        recipientAddress: statementAddresses.byContractId[pc.contractId],
        locale: statementLocales.byContractId[pc.contractId],
      });
    }
    return out;
  };

  // Warm up the statement PDFs right after saving (mijnhuurprofiel-style):
  // enqueue every frozen statement so "Overzicht downloaden" in the confirmed
  // view finds the document already on S3. Best effort — a failure here just
  // means the download will render on demand.
  // A statement the settlement froze is not sent again: the API reads it
  // itself (decision 16 of 2026-10-20).
  const warmStatementPdfs = (saved: Settlement) => {
    try {
      const frozen = saved.snapshot?.statements;
      const statements = frozen ?? buildAllStatements(saved);
      void Promise.allSettled(
        Object.entries(statements).map(([key, statement]) => {
          const colon = key.indexOf(":");
          const mode = key.slice(0, colon) as "tenant" | "owner";
          const partyId = key.slice(colon + 1);
          const variant = statementVariant(mode, partyId, statement);
          // As frozen: the API gives it its number.
          return api.post(`/settlements/${saved.id}/pdf`, {
            isV2: true,
            data: frozen ? { variant } : { variant, snapshot: statement },
          });
        }),
      );
    } catch {
      // Warm-up only; the on-demand path covers any failure.
    }
  };

  // The units a group settlement divides its keys by (vacant ones included,
  // the same set as the engine) and a unit's label, frozen on confirm.
  const settledGroupUnitIds =
    settlement.scope === "group" ? ownerUnitIds : settledUnitIds ?? [];
  const unitLabelOf = (id: string): string => {
    const p = statementAssignable.find(a => String(a.id) === id);
    return (
      p?.address ??
      p?.code ??
      realGroupUnits.find(u => String(u.id) === id)?.address ??
      id
    );
  };

  const buildSnapshot = (): SettlementSnapshot => {
    // Build the frozen snapshot from the already-computed result (real costs +
    // provisions). The confirm API just persists it — it does NOT recompute,
    // so the frozen view matches exactly what the wizard showed.
    const snapshot: SettlementSnapshot = {
      // The name the broker gave it, or the suggestion they kept.
      name: getDraftSettlementName(draft).trim() || undefined,
      invoiceIds: selected.map(i => i.id),
      // What the wizard read of each cost: the API refuses the confirm when a
      // cost changed since (paid, billed or edited in another tab).
      invoiceFigures: buildInvoiceFigures(selected),
      // A group's keys are frozen for the units the engine divided by only: a
      // stale weight of a unit that left the group was not part of the split,
      // so it must not inflate the frozen key's basis ("Verdeling" ratio)
      // either; an equal key gets 1 per unit, so its "1 / n" survives too.
      keySnapshots: freezeKeyWeights({ keys, unitIds: settledGroupUnitIds }),
      keyNames: Object.fromEntries(keys.map(k => [k.id, k.name])),
      // The group's units and the settled property with their labels on
      // confirm, so archiving or renaming one later rewrites nothing.
      groupUnits:
        settlement.scope === "group" || departureGroupId
          ? settledGroupUnitIds.map(id => ({
              id,
              label: unitLabelOf(id),
              archivedOn: unitArchivedOn[id],
            }))
          : undefined,
      propertyLabel: unitLabelOf(
        String(settlement.unitId ?? settlement.groupId ?? ""),
      ),
      // The broker's manual "betaald buiten Rentio" input — draftState is
      // cleared on confirm, so freeze it here.
      provisionExpectedOverride: draft.provisionExpectedOverride,
      ...(draft.provisionExpectedOverrideBySlice
        ? {
            provisionExpectedOverrideBySlice:
              draft.provisionExpectedOverrideBySlice,
          }
        : {}),
      // The slices of the provision this settlement weighed: a later
      // settlement in the tree skips its months for these slices only.
      provisionSlices,
      selectedKeyId: draft.selectedKeyId,
      // Freeze the whole distribution choice, not just the key — the statement
      // PDF needs the method (and its inputs) to reproduce the Samenvatting.
      distributionMethod: draft.distributionMethod,
      consumption: draft.consumption,
      buildingTotal: draft.buildingTotal,
      excessMode: draft.excessMode,
      companyAmounts: draft.companyAmounts,
      // Who each tenant's settlement is addressed to and who is on the lease,
      // so a later change to the contract changes neither.
      perContract: result.perContract.map(pc => {
        const contract = settledContracts.find(c => c.id === pc.contractId);
        return {
          ...pc,
          payerAccountId: rentalByContractId[pc.contractId]?.payerId,
          tenantNames: contract?.tenantNames,
          parentNames: contract?.parentNames,
          leaseAccountIds: contract ? leaseAccountIds(contract) : undefined,
        };
      }),
      totCost: result.totCost,
      // A departure settlement settles its lease's share of the costs, not
      // the costs themselves.
      costTotalExcl: isDeparture
        ? result.totCost
        : +selected.reduce((sum, i) => sum + i.amountExclVat, 0).toFixed(2),
      costTotalBtw: isDeparture
        ? +result.perContract
            .reduce((sum, pc) => sum + (pc.costVat ?? 0), 0)
            .toFixed(2)
        : +selected.reduce((sum, i) => sum + btwOf(i), 0).toFixed(2),
      ...(isDeparture && departureLease
        ? {
            departure: {
              contractId: departureLease.id,
              unitId: String(settlement.unitId),
              // The end the engine settled the lease up to: the lease as it
              // is now, also when it changed since the draft was made. A
              // later settlement charges the days after this one.
              until: departureLease.endDate,
              tenantName: departureLease.tenantName,
            },
          }
        : {}),
      ...(result.alreadySettled.length > 0
        ? { alreadySettled: result.alreadySettled }
        : {}),
      // The departures whose lease end moved, corrected here (decision 3).
      ...(result.departureCorrections
        ? { departureCorrections: result.departureCorrections }
        : {}),
      // Each unit's part of a cost split by readings (Y16).
      ...(result.unitSharesByInvoice
        ? { unitSharesByInvoice: result.unitSharesByInvoice }
        : {}),
      net: result.net,
      landlordTotal: result.landlordTotal,
      landlordBaseByCat: result.landlordBaseByCat,
      landlordVacancyByCat: result.landlordVacancyByCat,
      landlordVatByCat: result.landlordVatByCat,
      landlordPctByCat: result.landlordPctByCat,
      owners: result.owners,
      ownerNames: owners.nameByKey,
      statements: buildAllStatements({
        ...settlement,
        status: "confirmed",
        periodFrom: draft.period.from,
        periodTo: draft.period.to,
      }),
      actions: result.perContract.map(pc => {
        // Sign and amount follow the VAT-inclusive figure that is actually
        // billed (or refunded) — the same number payTenants filters on.
        const owedIncl = tenantOwedInclVat(pc, payCatMeta).incl;
        return {
          contractId: pc.contractId,
          type:
            draft.actions[pc.contractId] ??
            (owedIncl >= 0 ? "invite" : "refund"),
          amount: Math.abs(owedIncl),
          // Payment orders created in the in-flow payment steps are linked here
          // so the frozen settlement already knows its invitations.
          paymentOrderId: orderByContractRef.current[pc.contractId],
          paymentRequestId: requestByContractRef.current[pc.contractId],
        };
      }),
    };
    return snapshot;
  };

  // Persist the settlement as confirmed. Idempotent: a second call (e.g. the
  // payment step finishing) returns the row saved the first time.
  const persistSettlement = async (): Promise<Settlement> => {
    if (savedSettlementRef.current) return savedSettlementRef.current;
    reviewedCostsRef.current = selected;
    const snapshot = buildSnapshot();
    let saved: Settlement | undefined;
    if (isNewMode && virtualScope) {
      // No drafts: in new mode there is no DB row yet — the settlement is
      // created here in one go as a confirmed row.
      saved = await createSettlementApi({
        groupId: virtualScope.groupId,
        unitId: virtualScope.unitId,
        scope: virtualScope.scope,
        status: "confirmed",
        confirmedAt: todayIsoDay(),
        periodFrom: draft.period.from,
        periodTo: draft.period.to,
        snapshot,
      });
    } else {
      // Existing (old) draft row: confirm it.
      saved = (await confirm(snapshot)) ?? { ...settlement, snapshot };
    }
    // Keep the snapshot exactly as sent: a confirmed settlement only accepts
    // payment links on top of it (rentio-api-next refuses other changes).
    savedSettlementRef.current = { ...saved, snapshot };
    setOwnSavedId(saved.id);
    return savedSettlementRef.current;
  };

  // Record the payment orders/requests created so far on the confirmed
  // settlement — only the payment fields of its actions change. Runs after
  // every per-tenant payment step and at the end, so a tab closed halfway
  // still leaves the orders made so far linked (and the settlement then
  // cannot be deleted while they are open).
  const linkPayments = async (): Promise<Settlement> => {
    const saved = savedSettlementRef.current ?? (await persistSettlement());
    const base = saved.snapshot as SettlementSnapshot;
    const snapshot: SettlementSnapshot = {
      ...base,
      actions: withWizardLinks({
        actions: base.actions,
        links: {
          orderByContract: orderByContractRef.current,
          requestByContract: requestByContractRef.current,
        },
      }),
    };
    // Only the actions that changed travel, not the frozen statements again
    // (decision 16 of 2026-10-20).
    const changed = changedSettlementActions({
      stored: base.actions,
      next: snapshot.actions,
    });
    if (changed.length > 0) await recordSettlementActions(saved.id, changed);
    savedSettlementRef.current = { ...saved, snapshot };
    return savedSettlementRef.current;
  };

  // Best effort: stores a payment link this wizard made that the saved
  // settlement does not hold yet, because its own save failed. Never saves
  // the settlement itself.
  const storePendingLinks = async () => {
    const base = savedSettlementRef.current?.snapshot;
    if (
      !base ||
      !hasPendingWizardLinks({
        actions: base.actions,
        links: {
          orderByContract: orderByContractRef.current,
          requestByContract: requestByContractRef.current,
        },
      })
    ) {
      return;
    }
    await linkPayments().catch(() => undefined);
  };
  storeOnLeaveRef.current = () => {
    void storePendingLinks();
  };

  // Back to the cost list with the settlement open in the sidebar.
  const goToSaved = (saved: Settlement) => {
    warmStatementPdfs(saved);
    const base =
      saved.scope === "group"
        ? `/properties/${saved.groupId}`
        : `/properties/${saved.unitId}`;
    navigate(`${base}/costs?settlementId=${saved.id}`, { replace: true });
  };

  // The server refused the confirm because a cost changed since the wizard
  // read it. The costs are fetched again (now, whatever fetch is running),
  // compared with the ones the broker confirmed, and the broker goes back to
  // "Keuze van kosten", which says what changed. A deleted cost leaves the
  // selection; one that can no longer be settled drops out by itself. The
  // settlements are fetched again too: one may have taken a cost meanwhile.
  const showChangedCosts = async () => {
    refetchAllSettlements();
    let current: Invoice[];
    try {
      current = toWizardCosts(await reloadInvoices());
    } catch {
      // The dialog still says what happened; the list shows its own error.
      return;
    }
    const diff = diffReviewedCosts({
      reviewed: reviewedCostsRef.current,
      current,
    });
    setChangedCosts(isReviewedCostsDiffEmpty(diff) ? null : diff);
    const latest = latestDraftRef.current ?? draft;
    // The wizard moves at once; a draft row that fails to store it is saved
    // again on the next step.
    await saveDraft({
      selectedInvoiceIds: withoutRemovedCosts({
        selectedInvoiceIds: latest.selectedInvoiceIds,
        removed: diff.removed,
      }),
      stepIndex: invoicesStepIndex,
    }).catch(() => undefined);
  };

  // One line per changed cost: its name and what became of it.
  const changedCostLines = (diff: IReviewedCostsDiff): string[] => {
    const nameOf = (invoice: Invoice) =>
      [invoice.supplier, invoice.description].filter(Boolean).join(" — ") ||
      categoryLabel(invoice.category);
    return [
      ...diff.removed.map(invoice =>
        getLocalizedText("settlement.invoices.changed_since.removed", {
          cost: nameOf(invoice),
        }),
      ),
      ...diff.ineligible.map(({ invoice, reason }) =>
        getLocalizedText("settlement.invoices.changed_since.ineligible", {
          cost: nameOf(invoice),
          reason,
        }),
      ),
      ...diff.changed.map(({ invoice, from, to }) =>
        from === to
          ? getLocalizedText("settlement.invoices.changed_since.other", {
              cost: nameOf(invoice),
            })
          : getLocalizedText("settlement.invoices.changed_since.amount", {
              cost: nameOf(invoice),
              from: fmt(from),
              to: fmt(to),
            }),
      ),
    ];
  };

  // A 409 from the server's double-settlement guards gets its own message: a
  // cost or a provision month was settled elsewhere in the meantime.
  const showSaveFailed = (error: unknown) => {
    confirmDialog({
      type: "warning",
      title: getLocalizedText("settlement.save_failed.title"),
      info: getLocalizedText(
        getSaveFailedTextKey(error),
        getSaveFailedTextParams(error),
      ),
    });
  };

  // Without payments: save and leave.
  const doConfirm = async () => {
    goToSaved(await persistSettlement());
  };

  // Back from the first payment sub-step to "Verwerking", also once saved:
  // only the payment choice can change there, the amounts stay frozen. Not
  // while a submit runs: unmounting the form then would lose the orders it
  // creates.
  const backFromPayments = () => {
    if (paymentSubmitLockRef.current) return;
    setStep(confirmIndex);
  };

  // The orders exist but the settlement does not know them: say so and
  // name them, so the broker does not create them a second time from the
  // settlement. Refused because an invitation of a tenant was already open
  // (sent from another tab), the new order bills them twice: it has to be
  // withdrawn.
  const paymentLinkFailedDialog = (error: unknown): IConfirm => {
    const billed = payShares.filter(
      share => orderByContractRef.current[share.contractId] != null,
    );
    const values = {
      tenants: joinRecipientNamesAmong({ shares: billed, among: payShares }),
      orders: Array.from(
        new Set(
          billed.map(share => orderByContractRef.current[share.contractId]),
        ),
      ).join(", "),
    };
    const infoKey = isPaymentStillOpenRefusal(error)
      ? "settlement.payment_link_failed.duplicate"
      : "settlement.payment_link_failed.named";
    return {
      type: "warning",
      title: getLocalizedText("settlement.payment_link_failed.title"),
      info:
        billed.length > 0
          ? getLocalizedText(infoKey, values)
          : getLocalizedText("settlement.payment_link_failed"),
      secondaryAction: {
        title: getLocalizedText("payment_request.button.ok"),
      },
    };
  };

  // After the payment steps: the settlement already exists; link the orders
  // and requests that were just created into its snapshot, then leave. What
  // the broker should know of the run follows in turn, after the dialog
  // that ended it (`before`, see confirmInTurn): a link that failed.
  const finishAfterPayments = async (before?: IConfirm) => {
    const saved = savedSettlementRef.current ?? (await persistSettlement());
    let linkFailed: IConfirm | undefined;
    try {
      await linkPayments();
    } catch (error) {
      linkFailed = paymentLinkFailedDialog(error);
    }
    confirmInTurn([before, linkFailed]);
    goToSaved(savedSettlementRef.current ?? saved);
  };

  // "Versturen" first reads the server: the settlement's confirmed view, in
  // another tab, may have invited one of these tenants since this wizard
  // saved it. Refused, nothing is sent: the wizard says why and opens the
  // settlement, which shows what was sent (see inviteGuard.utils).
  const checkBeforePaying = async (shares: IPayShare[]): Promise<boolean> => {
    const saved = savedSettlementRef.current;
    if (!saved) return true;
    let blocks: IInviteBlock[];
    try {
      const [stored, orders] = await Promise.all([
        fetchStoredSettlement(saved.id),
        fetchLeaseOneOffOrders(shares.map(share => share.contractId)),
      ]);
      const storedActions = stored.snapshot?.actions ?? [];
      blocks = findInviteBlocks({
        targets: shares,
        actions: storedActions,
        // This wizard's own orders, linked or not yet.
        linkedOrderIds: [
          ...storedActions.flatMap(action =>
            action.paymentOrderId != null
              ? [Number(action.paymentOrderId)]
              : [],
          ),
          ...Object.values(orderByContractRef.current),
        ],
        confirmedAt: stored.confirmedAt ?? saved.confirmedAt,
        orders,
      });
    } catch {
      lockPaymentSubmit(false);
      confirmDialog({
        type: "warning",
        title: getLocalizedText("settlement.invite_not_sent.title"),
        info: getLocalizedText("settlement.invite_check_failed"),
        secondaryAction: {
          title: getLocalizedText("payment_request.button.ok"),
        },
      });
      return false;
    }
    if (blocks.length === 0) return true;
    void finishAfterPayments({
      type: "warning",
      title: getLocalizedText("settlement.invite_not_sent.title"),
      info: getInviteBlockedInfo({
        blocks,
        targets: shares,
        formatAmount: fmt,
        formatDay: fmtDate,
        extraKeys: ["settlement.invite_blocked.wizard_leaves"],
      }),
      secondaryAction: {
        title: getLocalizedText("payment_request.button.ok"),
      },
    });
    return false;
  };

  // Who receives the payment request of a lease with several tenants or a
  // parent: whoever pays the rent is preselected; without a rent order the
  // broker chooses. Frozen on save, so it is only asked before.
  const renderPayerChoice = () =>
    payerChoiceShares.length > 0 && (
      <Stack vertical spacing="tight">
        <DisplayText size="small" space="none">
          {getLocalizedText("settlement.confirm.payer_title")}
        </DisplayText>
        <TextStyle variation="subdued">
          {getLocalizedText("settlement.confirm.payer_info")}
        </TextStyle>
        {payerChoiceShares.map(share => (
          <Select
            key={share.contractId}
            id={`settlement-payer-${share.contractId}`}
            label={
              share.unitLabel
                ? `${share.tenantName} · ${share.unitLabel}`
                : share.tenantName
            }
            value={share.payerId}
            options={(
              rentalByContractId[share.contractId]?.payerCandidates ?? []
            ).map(candidate => ({
              value: candidate.accountId,
              label: getPayerOptionLabel(candidate),
            }))}
            onChange={(option: { value?: number } | null) => {
              const accountId = option?.value;
              if (accountId == null) return;
              setPayerChoiceByContract(current => ({
                ...current,
                [share.contractId]: accountId,
              }));
            }}
          />
        ))}
      </Stack>
    );

  // The title outside the stack (Lewis, 2026-10-19): StepHeader's own 16px
  // above the text under it, as in the other steps; inside the stack its
  // 24px came on top of them (40px).
  const renderConfirm = () => (
    <div>
      <StepHeader>{getLocalizedText("settlement.confirm.title")}</StepHeader>
      <Stack vertical spacing="loose">
        {isSaved ? (
          <Banner variation="info" hasDismiss={false}>
            {getLocalizedText("settlement.confirm.already_saved")}
          </Banner>
        ) : (
          <TextStyle variation="subdued">
            {getLocalizedText("settlement.confirm.final_note")}
          </TextStyle>
        )}
        <OptionListShared
          id="settlement-create-payments"
          multiple={false}
          // Nobody owes: there is nothing to create, so "none" is the only
          // option (a preselected "create" meant nothing).
          value={[createPayments && payShares.length > 0 ? "create" : "none"]}
          options={[
            ...(payShares.length > 0
              ? [
                  {
                    id: "create",
                    value: "create",
                    label: getLocalizedText(
                      "settlement.confirm.create_orders_with_balance",
                    ),
                  },
                ]
              : []),
            {
              id: "none",
              value: "none",
              label: getLocalizedText("settlement.confirm.no_orders_option"),
            },
          ]}
          onChange={handleSingleChoice(value =>
            setCreatePayments(value === "create"),
          )}
        />
        {createPayments &&
          payShares.length > 1 &&
          mixedOwners &&
          !isPerOwnerOffered && (
            <Banner variation="info" hasDismiss={false}>
              {getLocalizedText("settlement.confirm.mixed_owners")}
            </Banner>
          )}
        {createPayments &&
          payShares.length > 1 &&
          (!mixedOwners || isPerOwnerOffered) && (
            <Stack vertical spacing="tight">
              <DisplayText size="small" space="none">
                {getLocalizedText("settlement.confirm.create_orders")}
              </DisplayText>
              <OptionListShared
                id="settlement-payment-mode"
                multiple={false}
                value={[paymentMode]}
                options={[
                  {
                    id: "bulk",
                    value: "bulk",
                    label: getLocalizedText(
                      isPerOwnerOffered
                        ? "settlement.confirm.bulk_per_owner_option"
                        : "settlement.confirm.bulk_option",
                    ),
                  },
                  {
                    id: "perTenant",
                    value: "perTenant",
                    label: getLocalizedText(
                      "settlement.confirm.per_tenant_option",
                    ),
                  },
                ]}
                onChange={handleSingleChoice(value =>
                  setPaymentMode(value === "perTenant" ? "perTenant" : "bulk"),
                )}
              />
              {payPerOwner && <OwnerGroupList grouped={ownerGroups} />}
            </Stack>
          )}
        {createPayments && renderPayerChoice()}
        {createPayments && vatTaxableShares.length > 0 && (
          <Banner variation="warning" hasDismiss={false}>
            {getLocalizedText("settlement.confirm.vat_taxable_lease", {
              tenants: vatTaxableShares
                .map(share => share.payerName || share.tenantName)
                .join(", "),
            })}
          </Banner>
        )}
      </Stack>
    </div>
  );

  // Tenants who already got their payment order in this wizard (a retry, or
  // back via "Verwerking"): named after who the order bills, so the broker
  // sees they are not billed again, and told apart from the leases still to
  // bill in the form below.
  const renderAlreadyBilled = () =>
    billedShares.length > 0 && (
      <Banner variation="warning" hasDismiss={false}>
        {getLocalizedText("settlement.payments.already_billed", {
          tenants: joinRecipientNamesAmong({
            shares: billedShares,
            among: payShares,
          }),
        })}
      </Banner>
    );

  // One payment form for these tenants: each gets a payment order and open
  // payment of their own, on their own unit. Every
  // tenant without an order yet, or one owner's (see payPerOwner). A partial
  // failure links who was billed and reopens the form for the others.
  const renderBulkForm = (shares: IPayShare[], onBilled: () => void) => {
    const total = shares.reduce((sum, s) => sum + s.amount, 0);
    return (
      <PaymentFormContainer
        key={`settlement-payments-${paymentFormId.current}`}
        inline
        formId={paymentFormId.current}
        onSchemaCount={setPaymentSchemaCount}
        onStepChange={setInnerStepIndex}
        onVisibleStepsChange={(steps, activeVisibleIndex) => {
          setInnerSteps(steps);
          setInnerVisibleIndex(activeVisibleIndex);
        }}
        formRef={paymentFormRef}
        onFirstStepPrev={backFromPayments}
        hideCostRecap
        propertyIdOverride={shares[0].propertyId}
        prefillOverride={{
          description: shares[0].description,
          amount: total,
          vatPct: 0,
          costPayment: true,
          payerId: shares[0].payerId,
          payerName: shares[0].payerName,
          // A single tenant goes through the plain (non-split) path: linked
          // to their lease.
          ...(shares.length === 1 ? { contractId: shares[0].contractId } : {}),
          costSplits: shares.map(s => ({
            payerId: s.payerId,
            payerName: s.payerName,
            amount: s.amount,
            // Each tenant's order + open payment on their own unit, linked
            // to their own lease, described in their own language.
            propertyId: s.propertyId,
            unitLabel: s.unitLabel,
            contractId: s.contractId,
            description: s.description,
          })),
        }}
        onError={() => void handleBulkPaymentFailed(shares)}
        beforeSubmit={() => checkBeforePaying(shares)}
        onClose={() => {
          captureCreatedOrders(shares);
          onBilled();
        }}
      />
    );
  };

  const renderPayStep = () => {
    if (payShares.length === 0) return null;

    // Per tenant: one submission each, on that tenant's own property.
    if (payPerTenant) {
      const share = payShares[payIndex];
      if (!share) return null;
      return (
        <Stack vertical spacing="loose">
          <PaymentStepBanner
            shares={[share]}
            step={{
              index: Math.min(payIndex + 1, payShares.length),
              total: payShares.length,
            }}
          />
          {renderAlreadyBilled()}
          <PaymentFormContainer
            key={`settlement-payment-${paymentFormId.current}`}
            inline
            formId={paymentFormId.current}
            onSchemaCount={setPaymentSchemaCount}
            onStepChange={setInnerStepIndex}
            onVisibleStepsChange={(steps, activeVisibleIndex) => {
              setInnerSteps(steps);
              setInnerVisibleIndex(activeVisibleIndex);
            }}
            formRef={paymentFormRef}
            onFirstStepPrev={backFromPayments}
            hideCostRecap
            propertyIdOverride={share.propertyId}
            prefillOverride={{
              description: share.description,
              amount: share.amount,
              vatPct: 0,
              costPayment: true,
              payerId: share.payerId,
              payerName: share.payerName,
              contractId: share.contractId,
            }}
            onError={() => lockPaymentSubmit(false)}
            beforeSubmit={() => checkBeforePaying([share])}
            onClose={() => {
              captureCreatedOrders([share]);
              // Best effort here; finishAfterPayments links again and warns.
              linkPayments().catch(() => undefined);
              // Never a tenant who already has a payment order from this
              // wizard: that would bill them twice.
              const nextIndex = getNextOpenShareIndex({
                shares: payShares,
                orderByContract: orderByContractRef.current,
                from: payIndex + 1,
              });
              if (nextIndex !== -1) {
                // A fresh form per tenant: the form keeps its state per id,
                // so reusing it opened the next tenant's payment on the
                // previous one's last sub-step, with its answers.
                resetPaymentForm();
                setPayIndex(nextIndex);
                lockPaymentSubmit(false);
              } else {
                void finishAfterPayments();
              }
            }}
          />
        </Stack>
      );
    }

    // All at once per owner: one form per owner for their tenants without a
    // payment order yet, then each tenant of a unit without an owner.
    if (payPerOwner) {
      const run = ownerPayRuns[payRunIndex];
      const runShares = (run?.shares ?? []).filter(
        s => orderByContractRef.current[s.contractId] == null,
      );
      if (runShares.length === 0) return null;
      return (
        <Stack vertical spacing="loose">
          <OwnerGroupList
            grouped={ownerGroups}
            currentRunIndex={payRunIndex}
            isBilled={share =>
              orderByContractRef.current[share.contractId] != null
            }
          />
          <PaymentStepBanner shares={runShares} />
          {renderAlreadyBilled()}
          {renderBulkForm(runShares, () => {
            // Best effort here; finishAfterPayments links again and warns.
            linkPayments().catch(() => undefined);
            // The next owner (or tenant without one) with someone to bill;
            // a run that was sent is never opened again.
            const nextIndex = getNextOpenRunIndex({
              runs: ownerPayRuns,
              orderByContract: orderByContractRef.current,
              from: payRunIndex + 1,
            });
            if (nextIndex === -1) {
              void finishAfterPayments();
              return;
            }
            // A fresh form per owner, without the previous one's answers.
            resetPaymentForm();
            setPayRunIndex(nextIndex);
            lockPaymentSubmit(false);
          })}
        </Stack>
      );
    }

    // All at once, for the tenants who have no payment order yet.
    if (openShares.length === 0) return null;
    return (
      <Stack vertical spacing="loose">
        <PaymentStepBanner shares={openShares} />
        {renderAlreadyBilled()}
        {renderBulkForm(openShares, () => void finishAfterPayments())}
      </Stack>
    );
  };

  const renderStep = () => {
    if (isConfirmStep) return renderConfirm();
    if (isPayStep) return renderPayStep();
    switch (currentKey) {
      case "period":
        return <StepPeriod {...ctx} />;
      case "invoices":
        return (
          <>
            {changedCosts && (
              <Banner
                variation="warning"
                hasDismiss={false}
                title={getLocalizedText(
                  "settlement.invoices.changed_since.title",
                )}
              >
                {changedCostLines(changedCosts).map(line => (
                  <div key={line}>{line}</div>
                ))}
              </Banner>
            )}
            <StepInvoices {...ctx} />
          </>
        );
      case "keys":
        return <Step2Distribution {...ctx} result={result} />;
      case "provisions":
        return <Step3Provisions {...ctx} result={result} />;
      case "summary":
        return <Step4Summary {...ctx} result={result} />;
      default:
        return null;
    }
  };

  const isOnInnerSummary =
    paymentSchemaCount > 0 && innerStepIndex === paymentSchemaCount;
  // The "Verwerking" primary says what it does (getConfirmPrimaryLabelKey).
  const getConfirmPrimaryLabel = () =>
    getLocalizedText(
      getConfirmPrimaryLabelKey({ needsPayments, isSaved, isSaving }),
    );

  // Left-hand navigation. The internal "payments" entry is never shown as-is:
  // before entering the payment flow the sidebar simply ends at "Verwerking"
  // (choosing "Geen betaalopdrachten" keeps it that way), and once inside the
  // flow it's replaced by the flow's own visible sub-steps (+ its summary) so
  // the sidebar mirrors what the user actually walks through.
  const paymentAreaStart = confirmIndex + 1;
  const navSteps: StepDef[] =
    isPayStep && innerSteps.length > 0
      ? [
          ...steps.slice(0, paymentAreaStart),
          ...innerSteps.map(s => ({
            key: `pay-sub:${s.rawIndex}`,
            title: s.title,
          })),
          {
            key: "pay-summary",
            title: getLocalizedText("settlement.confirm.payment_overview"),
          },
        ]
      : steps.slice(0, paymentAreaStart);
  const navActiveIndex = isPayStep
    ? paymentAreaStart + innerVisibleIndex
    : stepIndex;
  const handleNavClick = (navIdx: number) => {
    // A saved settlement is final: its steps before "Verwerking" stay closed.
    // Nothing leaves the payment form while it submits: unmounted, it would
    // never report the orders it creates.
    if (isSaved && navIdx < confirmIndex) return;
    if (paymentSubmitLockRef.current) return;
    if (!isPayStep || innerSteps.length === 0) {
      setStep(navIdx);
      return;
    }
    // Inside the payment flow: clicks on the wizard steps leave the flow;
    // clicks on earlier payment sub-steps jump back within the form. Forward
    // clicks (incl. the summary entry) are ignored — the form validates its
    // way forward.
    if (navIdx < paymentAreaStart) {
      setStep(navIdx);
      return;
    }
    const target = navIdx - paymentAreaStart;
    if (target < innerVisibleIndex && innerSteps[target]) {
      paymentFormRef.current?.goToStep?.(innerSteps[target].rawIndex);
    }
  };

  return (
    <>
      <Card>
        <Grid spacing="extraLoose">
          <Grid.Item width={[1, 1, 3 / 12]}>
            <StepNavigation
              steps={navSteps}
              activeIndex={navActiveIndex}
              onStepClick={handleNavClick}
              lockedBefore={isSaved ? confirmIndex : 0}
              lockedHint={getLocalizedText("settlement.step.locked")}
            />
          </Grid.Item>
          <Grid.Item width={[1, 1, 9 / 12]}>
            {isDepartureTooFarAhead && departureLease && (
              <div style={{ marginBottom: 16 }}>
                <Banner variation="warning" hasDismiss={false}>
                  <Stack vertical spacing="tight">
                    <div>{departureTooFarAheadText}</div>
                    <div>
                      <Button
                        appearance="link"
                        // In a new tab, so the wizard stays open while Bea
                        // registers the notice on the lease's card (Lewis,
                        // 2026-10-20).
                        onClick={() =>
                          window.open(
                            `/properties/${departureLease.unitId}/contracts`,
                            "_blank",
                            "noopener",
                          )
                        }
                      >
                        {getLocalizedText("settlement.departure.open_lease")}
                      </Button>
                    </div>
                  </Stack>
                </Banner>
              </div>
            )}
            {movedLeaseEnd && !isSaved && (
              // The draft followed its lease's new end (M11).
              <div style={{ marginBottom: 16 }}>
                <Banner variation="info" hasDismiss={false}>
                  {getLocalizedText("settlement.departure.lease_end_moved", {
                    before: fmtDate(movedLeaseEnd.from),
                    end: fmtDate(movedLeaseEnd.to),
                  })}
                </Banner>
              </div>
            )}
            {/* A departure that cannot be settled yet shows its warning and
                nothing else: no period, notes or buttons to work through
                first (Lewis, 2026-10-21). */}
            {!isDepartureTooFarAhead && renderStep()}
            {isDepartureTooFarAhead ? null : isPayStep ? (
              <WizardFooter>
                <Button
                  isDisabled={isPaymentSubmitLocked}
                  onClick={() => {
                    if (paymentSubmitLockRef.current) return;
                    if (paymentFormRef.current?.handleStepPrev) {
                      paymentFormRef.current.handleStepPrev();
                    } else {
                      backFromPayments();
                    }
                  }}
                >
                  {getLocalizedText("costs.action.previous")}
                </Button>
                <Button
                  appearance="primary"
                  isSubmitting={
                    isOnInnerSummary &&
                    (!!isSubmittingPayment || isPaymentSubmitLocked)
                  }
                  onClick={() =>
                    isOnInnerSummary
                      ? handlePaymentSubmit()
                      : paymentFormRef.current?.handleExternalSubmit?.()
                  }
                >
                  {isOnInnerSummary
                    ? getLocalizedText("system.send")
                    : getLocalizedText("system.next")}
                </Button>
              </WizardFooter>
            ) : isConfirmStep ? (
              <WizardFooter
                messages={[
                  isPayerMissing &&
                    getLocalizedText("settlement.confirm.payer_missing"),
                  isLoadBlocked &&
                    getLocalizedText("settlement.load_failed_block"),
                ]}
              >
                <Button isDisabled={isSaved} onClick={handlePrev}>
                  {getLocalizedText("costs.action.previous")}
                </Button>
                <Button
                  appearance="primary"
                  isDisabled={isSaving || isPayerMissing || isLoadBlocked}
                  onClick={handleConfirmPrimary}
                >
                  {getConfirmPrimaryLabel()}
                </Button>
              </WizardFooter>
            ) : (
              <WizardFooter messages={[!stepValid && stepInvalidReason]}>
                {stepIndex > 0 && (
                  <Button onClick={handlePrev}>
                    {getLocalizedText("costs.action.previous")}
                  </Button>
                )}
                <Button
                  appearance="primary"
                  isDisabled={!stepValid}
                  onClick={handleNext}
                >
                  {getLocalizedText("costs.action.next")}
                </Button>
              </WizardFooter>
            )}
          </Grid.Item>
        </Grid>
      </Card>
    </>
  );
};
